import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_CLIENT_PROFILE_ENTRIES_COUNT } from "../types";
import {
  getClientProfileEntriesCountPending,
  getClientProfileEntriesCountFulfilled,
  getClientProfileEntriesCountRejected,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { CLIENT_PROFILE_ENTRY_MESSAGES } from "../constants/clientProfileEntryMessages";
import generateError from "../../../utilities/generateError";
import { setNoEntriesMessage } from "../actions";

const createPayload = (payload) => ({
  method: "get",
  url: "client/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setNoEntriesMessage(CLIENT_PROFILE_ENTRY_MESSAGES.NOT_FOUND)
        : { type: "" },
    (response) => getClientProfileEntriesCountFulfilled(response),
  ],
  onError: [
    getClientProfileEntriesCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getClientProfileEntriesCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_CLIENT_PROFILE_ENTRIES_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getClientProfileEntriesCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getClientProfileEntriesCountEpic$;



// WEBPACK FOOTER //
// ./src/features/client-profile/epics/getClientProfileEntriesCountEpic.js